import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const STORAGE_KEY = "__scroll:positions__";

function loadMap() {
  try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}; }
  catch { return {}; }
}
function saveMap(map) {
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map)); }
  catch {}
}

export default function ScrollRestoreRecent() {
  const location = useLocation();
  const navType = useNavigationType();
  const mapRef = useRef(loadMap());

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        mapRef.current[location.key] = {
          x: window.scrollX || 0,
          y: window.scrollY || 0,
        };
        saveMap(mapRef.current);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    const onBeforeUnload = () => {
      mapRef.current[location.key] = {
        x: window.scrollX || 0,
        y: window.scrollY || 0,
      };
      saveMap(mapRef.current);
    };
    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [location.key]);

  useEffect(() => {
    const positions = mapRef.current;

    const restoreScroll = (y) => {
      const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      window.scrollTo({ top: Math.min(y, maxY), left: 0, behavior: "auto" });
    };

    const scrollToHash = () => {
      const id = location.hash?.slice(1);
      if (!id) return false;
      const el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: "auto", block: "start" });
      return true;
    };

    if (navType === "POP") {
      const saved = positions[location.key];
      if (saved) {
        restoreScroll(saved.y);

        setTimeout(() => restoreScroll(saved.y), 50);
        setTimeout(() => restoreScroll(saved.y), 150);

        return;
      }
    }

    if (location.hash) {
      const ok = scrollToHash();
      if (!ok) requestAnimationFrame(scrollToHash);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.key, location.hash, navType]);

  return null;
}
